import { CmsContent } from '@/components/common/CmsContent/CmsContent';
import { CustomerQuotesCarousel } from '@/components/sign-up/CustomerQuotesCarousel/CustomerQuotesCarousel';
import { PetProfileModel } from '@/generated-client/pet-profile-a';
import { useFeatureValue } from '@/hooks/useFeatureValue';
import { FeatureConfigKeys } from '@/utils/athena-feature-config';

import styles from './SignUpContent.module.scss';

interface Props {
  onButtonClick: () => void;
  petProfiles?: PetProfileModel[];
}

export const SignUpContent = ({ onButtonClick, petProfiles }: Props) => {
  const signupV2Enabled = useFeatureValue(FeatureConfigKeys.SIGN_UP_PAGE_V2, false);

  if (signupV2Enabled)
    return (
      <div data-testid="v2-cms-content">
        <CmsContent handleAuthCheckAndConfirmationSheet={onButtonClick} zones={[2, 3, 4]} />
        <div className={styles.lightBlueBackground}>
          <CmsContent handleAuthCheckAndConfirmationSheet={onButtonClick} zones={[5]} />
        </div>
        <CustomerQuotesCarousel petProfiles={petProfiles} />
        <div className={styles.lightBlueBackground}>
          <CmsContent zones={[6]} />
        </div>
        <CmsContent zones={[7, 8, 9, 10]} />
      </div>
    );

  return (
    <>
      <div data-testid="v1-cms-content">
        <CmsContent handleAuthCheckAndConfirmationSheet={onButtonClick} />
      </div>
    </>
  );
};
